import React from 'react';
import { Terminal } from 'xterm';
import 'xterm/dist/xterm.css';
import { connect } from 'react-redux';
import _ from 'lodash';

import {
  setTerminal,
  setTerminalSocket,
  setIsDeviceInitialized,
  getDeviceRequest
} from '../reducers/devices';
import NotyHelper from '../api/NotyHelper';

const WS_URL = process.env.REACT_APP_WS_URL;
const HEARTBEAT_INTERVAL = 15000;

class TerminalComponent extends React.Component {
  componentDidMount() {
    const { dispatch, deviceId, token } = this.props;

    this.terminal = new Terminal({
      cursorBlink: false,
      disableStdin: true,
      theme: { background: '#1c1c1c' },
      fontSize: 14,
      rows: 30,
      cols: 100
    });

    this.terminal.open(this.el);

    this.socket = new WebSocket(`${WS_URL}tunnel/web/terminal/${deviceId}/`);

    this.socket.onopen = () => {
      this.socket.send(
        JSON.stringify({
          action: 'authentication',
          params: { token }
        })
      );

      this.startHeartbeat();
    };

    this.socket.onmessage = (e) => {
      if (e.data === 'hello' || e.data === 'pong') return;

      let data;
      try {
        data = JSON.parse(e.data);
      } catch {
        return;
      }

      switch (data.msg_type) {
        case 'run_command': {
          const { code, stdout, stderr } = data.detail;
          const line = code ? stderr : stdout;
          if (line) {
            this.terminal.write(line.replace(/\n/g, '\r\n'));
          }
          break;
        }

        case 'show_message':
          NotyHelper.error(data.params?.message);
          break;

        case 'device_init_success':
          dispatch(setIsDeviceInitialized(true));
          // getDeviceRequest dispatches via store.dispatch itself — wrapping it
          // in dispatch() would dispatch undefined and crash the router middleware.
          getDeviceRequest(deviceId);
          break;

        default:
          break;
      }
    };

    this.socket.onclose = (e) => {
      this.stopHeartbeat();

      if (_.isNumber(e.code) && e.code.toString().startsWith('30')) {
        NotyHelper.error(`WebSocket connection error: code ${e.code}`);
      }
    };

    this.socket.onerror = () => {
      console.error('WebSocket encountered an error.');
      this.stopHeartbeat();
    };

    this.terminal.onData((data) => {
      if (this.socket?.readyState === WebSocket.OPEN) {
        this.socket.send(
          JSON.stringify({
            action: 'run_command',
            params: { command: data }
          })
        );
      }
    });

    dispatch(setTerminal(this.terminal));
    dispatch(setTerminalSocket(this.socket));
  }

  startHeartbeat() {
    this.heartbeatTimer = setInterval(() => {
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        try {
          this.socket.send(
            JSON.stringify({
              action: 'ping',
              params: ''
            })
          );
        } catch (error) {
          console.error('Failed to send ping:', error);
          this.stopHeartbeat();
        }
      } else {
        console.warn('Socket not ready for heartbeat:', {
          socketExists: !!this.socket,
          readyState: this.socket ? this.socket.readyState : 'no socket'
        });
      }
    }, HEARTBEAT_INTERVAL);
  }

  stopHeartbeat() {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer);
      this.heartbeatTimer = null;
    }
  }

  componentWillUnmount() {
    this.stopHeartbeat();

    if (this.terminal) {
      this.terminal.dispose();
    }

    if (this.socket) {
      this.socket.close();
    }
  }

  render() {
    return <div ref={(el) => (this.el = el)} />;
  }
}

export default connect()(TerminalComponent);
